// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

/**
 * Plugin: Asios
 */
import axios from './plugins/axios.js'

/**
 * Plugin: Vue Local Storage
 * url: https://github.com/RobinCK/vue-ls
 */
import localStorage from './plugins/vue-local-storage.js'

/**
 * Plugin: Bootstrap
 */
import bootstrap from './plugins/bootstrap.js'

/**
 * CSS
 * INSPINIA, Font Awesome
 */
import css from './plugins/css'

/**
 * Plugin: Vue-Progressbar
 */
import progressbar from './plugins/vue-progressbar'

/**
 * Plugin: Vue-Lazyload
 * url: https://github.com/hilongjw/vue-lazyload
 */
import lazyload from './plugins/vue-lazyload'

/**
 * Plugin: Vue-touch
 * url: https://github.com/hilongjw/vue-touch
 */
import touch from './plugins/vue-touch'

/**
 * Plugin: Google map api
 */
import googleMap from './plugins/google-map'

/**
 * Plugin: V Autocomplete
 * url: https://github.com/paliari/v-autocomplete
 */
import autocomplete from './plugins/v-autocomplete'

/**
 * Plugin: V Autocomplete
 * url: http://numeraljs.com/
 */
import numeral from './plugins/numeral'

/**
 * Plugin: Vue JS Modal
 * url: https://github.com/euvl/vue-js-modal
 */
import modal from './plugins/vue-js-modal'

/**
 * Plugin: Vue Meta
 * url: https://github.com/declandewet/vue-meta
 */
import vueMeta from './plugins/vue-meta'

/**
 * Plugin: Vue clipboard 2
 * url: https://github.com/Inndy/vue-clipboard2
 */
import vueClipboard2 from './plugins/vue-clipboard-2'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  localStorage,
  css,
  bootstrap,
  progressbar,
  lazyload,
  touch,
  googleMap,
  autocomplete,
  numeral,
  modal,
  vueMeta,
  vueClipboard2,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js